import { createBrowserRouter } from "react-router-dom";
import { SiteLayout } from "../layouts/SiteLayout";
import { ContactPage } from "../pages/Contact";
import { DemoDashboardPage } from "../pages/DemoDashboard";
import { HomePage } from "../pages/Home";
import { NotFoundPage } from "../pages/NotFound";
import { PlatformPage } from "../pages/Platform";
import { PricingPage } from "../pages/Pricing";
import { ReportsPage } from "../pages/Reports";
import { ServicesPage } from "../pages/Services";
import { TestimonialsPage } from "../pages/Testimonials";

export const router = createBrowserRouter([
  { element: <SiteLayout />, children: [
    { path: "/", element: <HomePage /> },
    { path: "/services", element: <ServicesPage /> },
    { path: "/platform", element: <PlatformPage /> },
    { path: "/demo", element: <DemoDashboardPage /> },
    { path: "/reports", element: <ReportsPage /> },
    { path: "/testimonials", element: <TestimonialsPage /> },
    { path: "/packages", element: <PricingPage /> },
    { path: "/contact", element: <ContactPage /> },
    { path: "*", element: <NotFoundPage /> },
  ] },
]);
